export default __webpack_public_path__ + "static/media/Remove_Filters.a619fcc5.svg";